<template>
  <div class="tw-pb-20">
    <h2
      class="question-title with-subtext"
    >
      Here’s a preview of some non-hormonal products Winona has to offer. If you’re interested, proceed with onboarding to find out if you’re eligible.
    </h2>

    <div class="tw-grid tw-gap-6 tw-grid-cols-1 tw-py-4">
      <div class="tw-p-6 tw-flex tw-flex-col md:tw-flex-row tw-bg-[#FAFAFA] tw-rounded-xl tw-overflow-hidden tw-gap-4">
        <div class="tw-w-full md:tw-w-1/2">
          <img
            src="@/assets/images/onboarding/rejection/cream.png"
            alt="Estriol Face Cream"
            class="tw-w-full tw-h-full tw-object-cover tw-bg-purple-100 tw-rounded-xl"
          >
        </div>
        <div class="tw-flex tw-flex-col tw-justify-center tw-w-full md:tw-w-1/2">
          <h2 class="tw-text-2xl md:tw-text-[2rem] tw-mb-2">
            Estriol Face Cream with Tretinoin
          </h2>
          <p class="tw-text-lg tw-mb-1">
            New Patient Offer: <span class="tw-font-bold">{{ products['estriol-face-cream-with-tretinoin']?.metadata?.onboarding_upsellprice }}</span> per 3-mo. supply
          </p>
          <p class="tw-text-sm tw-mb-2">
            Regular Price: <s>{{ products['estriol-face-cream-with-tretinoin']?.metadata?.strikethroughprice }}</s> <span class="tw-text-[#1a6a72]">(Save ${{ getSaving(products['estriol-face-cream-with-tretinoin']?.metadata?.onboarding_upsellprice, products['estriol-face-cream-with-tretinoin']?.metadata?.strikethroughprice) }})</span>
          </p>
          <p class="tw-text-lg tw-mb-4">
            Uniquely formulated Estriol + Tretinoin skincare, designed with your skin in mind
          </p>
          <ul class="tw-text-sm tw-space-y-1 tw-text-[#1a6a72]">
            <li class="tw-flex tw-items-center tw-gap-1">
              <svg
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.32409 15.2156C11.3308 15.2156 14.6482 11.891 14.6482 7.89148C14.6482 3.88477 11.3237 0.567383 7.31692 0.567383C3.31739 0.567383 0 3.88477 0 7.89148C0 11.891 3.32457 15.2156 7.32409 15.2156ZM7.32409 13.9949C3.93492 13.9949 1.22787 11.2807 1.22787 7.89148C1.22787 4.5023 3.92773 1.78807 7.31692 1.78807C10.7061 1.78807 13.4276 4.5023 13.4276 7.89148C13.4276 11.2807 10.7133 13.9949 7.32409 13.9949Z"
                  fill="#1A6A72"
                />
                <path
                  d="M6.56662 11.1406C6.80357 11.1406 7.00461 11.0257 7.14823 10.8031L10.4297 5.64032C10.5087 5.49671 10.602 5.33874 10.602 5.18077C10.602 4.85765 10.3148 4.64941 10.0133 4.64941C9.83373 4.64941 9.6542 4.7643 9.5178 4.97253L6.53788 9.75474L5.12332 7.9237C4.95098 7.69393 4.79302 7.63651 4.59196 7.63651C4.2832 7.63651 4.03906 7.8878 4.03906 8.20378C4.03906 8.36175 4.10369 8.51254 4.20421 8.64894L5.95626 10.8031C6.13577 11.0401 6.32962 11.1406 6.56662 11.1406Z"
                  fill="#1A6A72"
                />
              </svg>
              Reduced fine lines & wrinkles
            </li>
            <li class="tw-flex tw-items-center tw-gap-1">
              <svg
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.32409 15.2156C11.3308 15.2156 14.6482 11.891 14.6482 7.89148C14.6482 3.88477 11.3237 0.567383 7.31692 0.567383C3.31739 0.567383 0 3.88477 0 7.89148C0 11.891 3.32457 15.2156 7.32409 15.2156ZM7.32409 13.9949C3.93492 13.9949 1.22787 11.2807 1.22787 7.89148C1.22787 4.5023 3.92773 1.78807 7.31692 1.78807C10.7061 1.78807 13.4276 4.5023 13.4276 7.89148C13.4276 11.2807 10.7133 13.9949 7.32409 13.9949Z"
                  fill="#1A6A72"
                />
                <path
                  d="M6.56662 11.1406C6.80357 11.1406 7.00461 11.0257 7.14823 10.8031L10.4297 5.64032C10.5087 5.49671 10.602 5.33874 10.602 5.18077C10.602 4.85765 10.3148 4.64941 10.0133 4.64941C9.83373 4.64941 9.6542 4.7643 9.5178 4.97253L6.53788 9.75474L5.12332 7.9237C4.95098 7.69393 4.79302 7.63651 4.59196 7.63651C4.2832 7.63651 4.03906 7.8878 4.03906 8.20378C4.03906 8.36175 4.10369 8.51254 4.20421 8.64894L5.95626 10.8031C6.13577 11.0401 6.32962 11.1406 6.56662 11.1406Z"
                  fill="#1A6A72"
                />
              </svg>
              Better tone & texture
            </li>
          </ul>
        </div>
      </div>

      <div class="tw-p-6 tw-flex tw-flex-col md:tw-flex-row-reverse tw-bg-[#FAFAFA] tw-rounded-xl tw-overflow-hidden tw-gap-4">
        <div class="tw-w-full md:tw-w-1/2">
          <img
            src="@/assets/images/onboarding/rejection/minoxidil.png"
            alt="Estriol Face Cream"
            class="tw-w-full tw-h-full tw-object-cover tw-bg-purple-100 tw-rounded-xl"
          >
        </div>
        <div class="tw-flex tw-flex-col tw-justify-center tw-w-full md:tw-w-1/2">
          <h2 class="tw-text-2xl md:tw-text-[2rem] tw-mb-2">
            Minoxidil Hair Serum
          </h2>
          <p class="tw-text-lg tw-mb-1">
            New Patient Offer: <span class="tw-font-bold">{{ products['minoxidil-hair-serum']?.metadata?.onboarding_upsellprice }}</span> per 3-mo. supply
          </p>
          <p class="tw-text-sm tw-mb-2">
            Regular Price: <s>{{ products['minoxidil-hair-serum']?.metadata?.strikethroughprice }}</s> <span class="tw-text-[#1a6a72]">(Save ${{ getSaving(products['minoxidil-hair-serum']?.metadata?.onboarding_upsellprice, products['minoxidil-hair-serum']?.metadata?.strikethroughprice) }})</span>
          </p>
          <p class="tw-text-lg tw-mb-4">
            Topical Minoxidil for thicker hair in 3-6 months
          </p>
          <ul class="tw-text-sm tw-space-y-1 tw-text-[#1a6a72]">
            <li class="tw-flex tw-items-center tw-gap-1">
              <svg
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.32409 15.2156C11.3308 15.2156 14.6482 11.891 14.6482 7.89148C14.6482 3.88477 11.3237 0.567383 7.31692 0.567383C3.31739 0.567383 0 3.88477 0 7.89148C0 11.891 3.32457 15.2156 7.32409 15.2156ZM7.32409 13.9949C3.93492 13.9949 1.22787 11.2807 1.22787 7.89148C1.22787 4.5023 3.92773 1.78807 7.31692 1.78807C10.7061 1.78807 13.4276 4.5023 13.4276 7.89148C13.4276 11.2807 10.7133 13.9949 7.32409 13.9949Z"
                  fill="#1A6A72"
                />
                <path
                  d="M6.56662 11.1406C6.80357 11.1406 7.00461 11.0257 7.14823 10.8031L10.4297 5.64032C10.5087 5.49671 10.602 5.33874 10.602 5.18077C10.602 4.85765 10.3148 4.64941 10.0133 4.64941C9.83373 4.64941 9.6542 4.7643 9.5178 4.97253L6.53788 9.75474L5.12332 7.9237C4.95098 7.69393 4.79302 7.63651 4.59196 7.63651C4.2832 7.63651 4.03906 7.8878 4.03906 8.20378C4.03906 8.36175 4.10369 8.51254 4.20421 8.64894L5.95626 10.8031C6.13577 11.0401 6.32962 11.1406 6.56662 11.1406Z"
                  fill="#1A6A72"
                />
              </svg>
              Clinically-proven
            </li>
            <li class="tw-flex tw-items-center tw-gap-1">
              <svg
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.32409 15.2156C11.3308 15.2156 14.6482 11.891 14.6482 7.89148C14.6482 3.88477 11.3237 0.567383 7.31692 0.567383C3.31739 0.567383 0 3.88477 0 7.89148C0 11.891 3.32457 15.2156 7.32409 15.2156ZM7.32409 13.9949C3.93492 13.9949 1.22787 11.2807 1.22787 7.89148C1.22787 4.5023 3.92773 1.78807 7.31692 1.78807C10.7061 1.78807 13.4276 4.5023 13.4276 7.89148C13.4276 11.2807 10.7133 13.9949 7.32409 13.9949Z"
                  fill="#1A6A72"
                />
                <path
                  d="M6.56662 11.1406C6.80357 11.1406 7.00461 11.0257 7.14823 10.8031L10.4297 5.64032C10.5087 5.49671 10.602 5.33874 10.602 5.18077C10.602 4.85765 10.3148 4.64941 10.0133 4.64941C9.83373 4.64941 9.6542 4.7643 9.5178 4.97253L6.53788 9.75474L5.12332 7.9237C4.95098 7.69393 4.79302 7.63651 4.59196 7.63651C4.2832 7.63651 4.03906 7.8878 4.03906 8.20378C4.03906 8.36175 4.10369 8.51254 4.20421 8.64894L5.95626 10.8031C6.13577 11.0401 6.32962 11.1406 6.56662 11.1406Z"
                  fill="#1A6A72"
                />
              </svg>
              Promotes hair regrowth
            </li>
          </ul>
        </div>
      </div>
    </div>

    <template v-if="!hasHeartRelatedConditions">
      <hr class="tw-border-[#E9E9E9] !tw-my-10">

      <div>
        <h2 class="tw-text-2xl md:tw-text-[2rem] tw-mb-2">
          Complete your treatment plan with an add-on:
        </h2>
        <h2 class="tw-text-2xl md:tw-text-[1.625rem] tw-mb-2 tw-text-[#787878] tw-leading-tight">
          Sildenafil Arousal Cream is only available with the purchase of Estriol + Tretinoin Skin Cream or Minoxidil Hair Serum.
        </h2>
      </div>

      <div class="tw-p-6 tw-flex tw-flex-col md:tw-flex-row tw-bg-[#FAFAFA] tw-rounded-xl tw-overflow-hidden tw-gap-4">
        <div class="tw-w-full md:tw-w-1/2">
          <img
            src="@/assets/images/onboarding/rejection/blossom.png"
            alt="Estriol Face Cream"
            class="tw-w-full tw-h-full tw-object-cover tw-bg-purple-100 tw-rounded-xl"
          >
        </div>
        <div class="tw-flex tw-flex-col tw-justify-center tw-w-full md:tw-w-1/2">
          <h2 class="tw-text-2xl md:tw-text-[2rem] tw-mb-2">
            Sildenafil Arousal Cream
          </h2>
          <p class="tw-text-lg tw-mb-1">
            New Patient Offer: <span class="tw-font-bold">{{ products['sildenafil-arousal-cream']?.metadata?.upsellprice }}</span> {{ products['sildenafil-arousal-cream']?.metadata?.upsellpriceunit }}
          </p>
          <p class="tw-text-sm tw-mb-2">
            Regular Price: <s>{{ products['sildenafil-arousal-cream']?.metadata?.strikethroughprice }}</s> <span class="tw-text-[#1a6a72]">(Save ${{ getSaving(products['sildenafil-arousal-cream']?.metadata?.upsellprice, products['sildenafil-arousal-cream']?.metadata?.strikethroughprice) }})</span>
          </p>
          <p class="tw-text-lg tw-mb-4">
            Intimacy enhancement for use with or without a partner.
          </p>
        </div>
      </div>

      <div class="tw-flex tw-mt-6">
        <svg
          class="tw-mt-1 tw-mr-2"
          width="14"
          height="15"
          viewBox="0 0 14 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.97266 14.168C6.02018 14.168 5.1224 13.9857 4.2793 13.6211C3.44076 13.2565 2.7002 12.7529 2.05762 12.1104C1.41504 11.4678 0.911458 10.7272 0.546875 9.88867C0.182292 9.04557 0 8.14779 0 7.19531C0 6.24284 0.182292 5.34733 0.546875 4.50879C0.911458 3.66569 1.41276 2.92285 2.05078 2.28027C2.69336 1.6377 3.43392 1.13411 4.27246 0.769531C5.11556 0.404948 6.01335 0.222656 6.96582 0.222656C7.91829 0.222656 8.81608 0.404948 9.65918 0.769531C10.5023 1.13411 11.2451 1.6377 11.8877 2.28027C12.5303 2.92285 13.0339 3.66569 13.3984 4.50879C13.763 5.34733 13.9453 6.24284 13.9453 7.19531C13.9453 8.14779 13.763 9.04557 13.3984 9.88867C13.0339 10.7272 12.5303 11.4678 11.8877 12.1104C11.2451 12.7529 10.5023 13.2565 9.65918 13.6211C8.82064 13.9857 7.92513 14.168 6.97266 14.168ZM6.97266 13.0059C7.7793 13.0059 8.53353 12.8555 9.23535 12.5547C9.93717 12.2539 10.5547 11.8392 11.0879 11.3105C11.6211 10.7773 12.0358 10.1598 12.332 9.45801C12.6328 8.75618 12.7832 8.00195 12.7832 7.19531C12.7832 6.38867 12.6328 5.63444 12.332 4.93262C12.0312 4.23079 11.6143 3.61328 11.0811 3.08008C10.5524 2.54688 9.9349 2.13216 9.22852 1.83594C8.52669 1.53516 7.77246 1.38477 6.96582 1.38477C6.15918 1.38477 5.40495 1.53516 4.70312 1.83594C4.0013 2.13216 3.38607 2.54688 2.85742 3.08008C2.32878 3.61328 1.91406 4.23079 1.61328 4.93262C1.31706 5.63444 1.16895 6.38867 1.16895 7.19531C1.16895 8.00195 1.31706 8.75618 1.61328 9.45801C1.91406 10.1598 2.32878 10.7773 2.85742 11.3105C3.39062 11.8392 4.00814 12.2539 4.70996 12.5547C5.41178 12.8555 6.16602 13.0059 6.97266 13.0059ZM6.96582 8.42578C6.61491 8.42578 6.4349 8.24577 6.42578 7.88574L6.33691 4.26953C6.33236 4.09635 6.38704 3.9528 6.50098 3.83887C6.61947 3.72493 6.77214 3.66797 6.95898 3.66797C7.14128 3.66797 7.29167 3.72721 7.41016 3.8457C7.5332 3.95964 7.59245 4.10319 7.58789 4.27637L7.48535 7.88574C7.48079 8.24577 7.30762 8.42578 6.96582 8.42578ZM6.96582 10.6475C6.7653 10.6475 6.59212 10.5791 6.44629 10.4424C6.30046 10.3011 6.22754 10.1325 6.22754 9.93652C6.22754 9.74056 6.30046 9.57422 6.44629 9.4375C6.59212 9.29622 6.7653 9.22559 6.96582 9.22559C7.16634 9.22559 7.33952 9.29395 7.48535 9.43066C7.63119 9.56738 7.7041 9.736 7.7041 9.93652C7.7041 10.137 7.62891 10.3057 7.47852 10.4424C7.33268 10.5791 7.16178 10.6475 6.96582 10.6475Z"
            fill="#1A6A72"
          />
        </svg>

        Sildenafil Arousal Cream is only available for those without contraindications related to heart disease.
      </div>
    </template>

    <OnboardingCTAContainer custom>
      <div class="tw-w-full tw-flex tw-gap-2 tw-flex-col md:tw-flex-row tw-justify-center tw-items-center tw-max-w-[650px] tw-mx-auto">
        <b-button
          class="tw-text-base tw-max-w-full md:tw-text-lg lg:tw-max-w-[326px] xl:tw-max-w-[350px] slight-rounded tw-border-[#312849] tw-text-[#312849]"
          pill
          block
          variant="outline-info"
          @click="onExit"
        >
          I'm not interested
        </b-button>
        <b-button
          pill
          block
          variant="info"
          class="slight-rounded tw-max-w-full tw-self-center tw-mt-0 tw-text-base md:tw-text-lg lg:tw-max-w-[326px] xl:tw-max-w-[350px] 2xl:tw-max-w-[400px]"
          @click="onContinue"
        >
          Continue
        </b-button>
      </div>
    </OnboardingCTAContainer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { OnboardingService } from '@/services/onboarding.service';
import OnboardingCTAContainer from '@/components/onboarding/OnboardingCTAContainer';
import components from '@/components'

export default {
  name: 'TreatmentsRejection',
  components: {
    ...components,
    OnboardingCTAContainer
  },
  props: {},
  data() {
    return {
      products: {
        'estriol-face-cream-with-tretinoin': {
          metadata: {
            onboarding_upsellprice: '',
            strikethroughprice: ''
          }
        },
        'minoxidil-hair-serum': {
          metadata: {
            onboarding_upsellprice: '',
            strikethroughprice: ''
          }
        },
        'sildenafil-arousal-cream': {
          metadata: {
            onboarding_upsellprice: '',
            strikethroughprice: ''
          }
        }
      },
    };
  },
  computed: {
    ...mapState('onboarding', ['onboardingPatient']),
    hasHeartRelatedConditions() {
      const medicalConditions = this.onboardingPatient?.healthquestions?.find(q => q.questionid === 2.4)
      return medicalConditions && medicalConditions.answer.includes('heartrelated');
    },
  },
  async created() {
    await this.$store.dispatch('onboarding/getPatientOnboarding');
    const response = await OnboardingService.getNonHRTOnboarding()
    this.$set(this, 'products', response.data.reduce((acc, product) => {
      acc[product.slug] = product;
      return acc;
    }, {}));
  },
  methods: {
    onExit() {
      OnboardingService.onboardingEvent('NonHRTNotInterested', {
        userid: this.onboardingPatient?.id,
      });
      this.$emit('exit');
    },
    onContinue() {
      OnboardingService.onboardingEvent('NonHRTInterested', {
        userid: this.onboardingPatient?.id,
      });
      this.$emit('continue');
    },
    getSaving(regular, promo) {
      try {
        const regularPrice = parseFloat(regular.replace('$', '').trim());
        const promoPrice = parseFloat(promo.replace('$', '').trim());

        if (isNaN(regularPrice) || isNaN(promoPrice)) {
          return 0;
        }

        return promoPrice - regularPrice;
      } catch (error) {
        return 0;
      }
    },
  }
};
</script>